{
  "agb-dialog": {
    "text": {
      "agb": "Conditions générales de vente"
    },
    "buttons": {
      "close": "Fermer"
    }
  }
}
